import styled from "styled-components";
import { Type } from "discover.medical.react-component-library";

export const StyledWrapper = styled.div`
  font-size: ${({ theme }) => theme.font.size.sm};
  width: 100%;
  &:not(:first-child) {
    padding-top: ${({ theme }) => theme.space.lg};
  }
  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.gray400};
    padding-bottom: ${({ theme }) => theme.space.lg};
  }
`;

export const StyledLabel = styled(Type)`
  padding-bottom: ${({ theme }) => theme.space.sm};
`;
